<template>
  <v-btn icon @click="print" v-if="!$vuetify.breakpoint.mobile"><v-icon>mdi-printer</v-icon></v-btn>
</template>

<script>
export default {
  name: 'PrintList',
	props: {
    table: {type:Object,required:false},
    title: {type:String, required:true},
    subTitle: {type:String, required:false, default:''},
    pageSize: {type:String,required:false, default:'portrait'}
  },
  methods: {
    print() {
      const columns = this.table.headers.reduce((columns, column) =>
        columns + ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? 1 : 0), 0);
      const lines = [
              `<table style="width:100%;border-spacing:0">
                <thead>
                  <tr>
                    <th colspan="${columns}" class="sup-title">
                      ${this.$store.getters.company.customerName} @ ${this.$store.getters.company.companyName}
                    </th>
                  </tr>
                  <tr>
                    <th colspan="${columns}" class="title">${this.title}</th>
                  </tr>
                  <tr>
                      <th colspan="${columns}" class="sub-title">${this.subTitle}</th>
                  </tr>
                 <tr class="header">`];
        this.table.headers.forEach(column => {
          if ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none'))
            lines.push(`<th style="width:${(column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? column.width : '0%'};text-align:${column.align ? column.align : 'left'}">${column.text}</th>`);
        })
        lines.push('</tr></thead>');
        lines.push('<tbody>');
      this.table.internalCurrentItems.forEach(item => {
        lines.push('<tr>')
        this.table.headers.forEach(column => {
          if ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none')) {
            let value = item;
            column.value.split('.').forEach(key => value = value[key]);

            const slot = this.table.$scopedSlots['item.'+column.value];
            if (slot) {
              const slotA = slot({item,value,printing:true});
              value = slotA ? slotA[0].text : '';
            }
            if (value == null || value == undefined)
              value = "";
            lines.push(`<td style="width:${(column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? column.width : '0%'};text-align:${column.align ? column.align : 'left'}">${value}</td>`);
          }
        })
        lines.push('</tr>')
      })

      if (this.table.$scopedSlots['body.appendPrint'])
        lines.push(this._htmlFromVNode(this.table.$scopedSlots['body.appendPrint']()[0]));
      else if (this.table.$scopedSlots['body.append'])
        lines.push(this._htmlFromVNode(this.table.$scopedSlots['body.append']({headers:this.table.headers,printing:true})[0]));

      lines.push('</tbody></table>');
      this.printHtml(`<!DOCTYPE html>
                            <html>
                              <head>
                                <style>
                                  @page {size:${this.pageSize}}
                                  body {font-family: Roboto, sans-serif; font-size:14px}
                                  th,td {height:36px;padding:0 16px}
                                  .title {font-size:18px;text-transform:uppercase}
                                  .sup-title {font-weight:normal;font-size:22px}
                                  .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                                  .header th {border-bottom:1px solid #000;margin-bottom:20px}
                                  .text-right {text-align:right}
                                  .font-weight-bold {font-weight:bold}
                                  .total-row {font-weight:bold}
                                </style>
                              </head>
                              <body>
                                ${lines.join('')}
                              </body>
                            </html>`);
    },
    _htmlFromVNode(vNode) {
      if (vNode.tag) {
        let childrenHTML = '';
        if (vNode.children) {
          for (const child of vNode.children)
            childrenHTML += this._htmlFromVNode(child);
        }
        let attrs = '';
        if (vNode.data && vNode.data.attrs) {
          for (const attr in vNode.data.attrs)
            attrs += ` ${attr}="${vNode.data.attrs[attr]}"`;
        }
        return `<${vNode.tag} class="${vNode.data && vNode.data.staticClass ? vNode.data.staticClass : ''}"${attrs}>${childrenHTML}</${vNode.tag}>`;
      }
      if (vNode.text)
        return vNode.text;
      return '';
    },
    printHtml(html, image) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      if (image) {
        const imageElement = doc.getElementById(image.id);
        imageElement.onload = () => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }
        imageElement.src = image.src;
      }

      else {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }
    }
  }
}
</script>